<script lang="ts">
    interface Props {
        name: string;
    }

    let { name }: Props = $props();
</script>

<span class="reptile-product-name">{name}</span>

<style lang="scss">
    @use '@otto-ec/design-tokens/tokens';
    @use '@shared/styles/mixins';

    .reptile-product-name {
        overflow: hidden;
        text-overflow: ellipsis;
        display: inline;
        font-family: 'OttoSansMedium', tokens.$oc-semantic-font-copy-font-family;
        font-weight: 500;
        font-size: tokens.$oc-base-font-size-87;
        line-height: tokens.$oc-base-font-line-height-125;
        @include mixins.line-clamp(2);
    }
</style>
